import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    gap: 26px;
    margin-bottom: 24px;
    img {
        width: 100px;
        height: 40px;
    }
`

export const SellerInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    & h2 {
        font-size: 20px;
        color: #2E2D37;
        font-weight: 500;
        width: 250px;
    }
`

export const DefaultLogo = styled.div`
    width: 64px;
    height: 40px;
    flex-shrink: 0;
    background: url('/assets/img/SellerArea/default-seller-logo.svg') no-repeat center #ECEDF2;
    border-radius: 8px;  
`

export const Location = styled.span`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 400;

    &:before {
        content: "";
        background-image: url('/assets/img/icon/icon-location.svg');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100%;
        width: 16px;
        height: 16px;
        display: inline-block;
    } 
`
